import React, { useContext, useMemo, useState } from "react";
import AlertContext from "../../context/AlertContext";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from "@mui/material";
import _ from "lodash";
import Search from "../CommonComponents/Search";
import ZoomBatchCarousel from "./ZoomBatchCarousel";
import Button from "../Button";
import constants from "../../constants";
import Loading from "../Notification-Loading/Loading/Loading";
import Popup from "./Popup";
import PopupTitleCom from "./PopupTitleCom";
import useAxiosPrivate from "../../Hooks/useAxiosPrivate";
import ModuleHooks from "../../Hooks/ModuleHooks";

const ZoomPopup = ({
  batchdata,
  setBatchData,
  filteredBatchStudents,
  setFilteredBatchStudents,
  batchStudentsData,
}) => {
  const {
    showzoommodal,
    setshowzoommodal,
    isLoaded,
    setIsLoaded,
    handleUnAuthAlert,
    setShowNotify
  } = useContext(AlertContext);
  const { handlePopupStates, clearPopupStates } = ModuleHooks();
  const axios = useAxiosPrivate();
  console.log("batch student lists", batchdata);
  const [selectedStudents, setSelectedStudents] = useState([]);

  const [openPopup, setOpenPopup] = useState(false);
  const [popupType, setPopupType] = useState(constants.TEST_ACTIONS.WARN);

  const [popupBodyValue, setPopupBodyValue] = useState("");
  const [isDisable, setIsDisable] = useState(false);
  let primaryBtnText = "Send Warning";
  let popupTitleCom = null;
  const studentNames = useMemo(() => {
    let newDetails = selectedStudents.map((student) => {
      let index = student.name.indexOf("(");
      return index < 0 ? student.name : student.name.substring(0, index);
    });
    return newDetails.join(",");
  }, [selectedStudents]);
  // console.log("studentNames", studentNames);

  if (popupType === constants.TEST_ACTIONS.WARN) {
    popupTitleCom = (
      <PopupTitleCom
        title="Warn Participants:"
        caption={studentNames}
        setOpenPopup={setOpenPopup}
      />
    );
    primaryBtnText = "Send Warning";
  } else if (popupType === constants.TEST_ACTIONS.REMOVE_FROM_TEST) {
    popupTitleCom = (
      <PopupTitleCom
        title="Remove Participants from Test:"
        caption={studentNames}
        setOpenPopup={setOpenPopup}
      />
    );
    primaryBtnText = "Remove from Test";
  } else {
    popupTitleCom = (
      <PopupTitleCom
        title="Remove Participants from Batch:"
        caption={studentNames}
        setOpenPopup={setOpenPopup}
      />
    );
    primaryBtnText = "Remove from Batch";
  }

  const handleCloseDialog = () => {
    let newDetails = JSON.parse(JSON.stringify(batchdata));
    for (let batch in newDetails) {
      for (let student in newDetails[batch]) {
        newDetails[batch][student].checked = false;
      }
    }
    setBatchData(newDetails);
    batchStudentsData.current = newDetails;
    setFilteredBatchStudents(newDetails);
    setSelectedStudents([]);
    setshowzoommodal(false);
  };

  const handleSearch = (event) => {
    let value = event.target.value?.toLowerCase();
    let result = _.transform(
      batchdata,
      (result, category, key) => {
        const filteredCategory = _.pickBy(category, (item) =>
          item.name?.toLowerCase().includes(value)
        );
        if (!_.isEmpty(filteredCategory)) {
          result[key] = filteredCategory;
        }
      },
      {}
    );
    setFilteredBatchStudents(result);
  };

  const handleOpenPopup = (action) => {
    if (selectedStudents.length > 0) {
      setPopupType(action);
      setOpenPopup(true);
    }
  };

  const handleClosePopup = () => {
    setOpenPopup(false);
    setPopupType(constants.TEST_ACTIONS.WARN);
  };

  const handlePopupOkFunc = () => {
    handleUnAuthAlert();
    clearPopupStates();
  };

  const handleResponse = (title, msg, isUnAuth) => {
    setShowNotify({
      show: true,
      title: title,
      msg: msg,
    });
  };

  const handleTestAction = () => {
    if (selectedStudents.length > 0) {
      let students = _.map(selectedStudents, (student, index) => {
        return {
          action: popupType ?? 0,
          actionText: popupBodyValue ?? "",
          testdata: {
            lpid: student.lpid,
            lpconfigid: student.lpconfigid,
            learnerid: student.learnerid,
          },
        };
      });
      setIsLoaded(true);
      setIsDisable(true);
      axios
        .post("node/zoom/admin/action", students, {
          headers: {
            "Content-type": "application/json",
          },
        })
        .then((res) => {
          console.log("res", res.data);
          if (res.data.resultCode === constants.RESULT_STATUS.SUCCESS) {
            let newDetails = JSON.parse(JSON.stringify(batchdata));
            for (let batch in newDetails) {
              for (let student in newDetails[batch]) {
                newDetails[batch][student].checked = false;
              }
            }
            setBatchData(newDetails);
            batchStudentsData.current = newDetails;
            setFilteredBatchStudents(newDetails);
            setSelectedStudents([]);
            setOpenPopup(false);
            setPopupBodyValue("");
          } else {
            handleResponse(
              "Error !",
              "Something went wrong… Please, try again",
              false
            );
            return;
          }
        })
        .catch((error) => {
          console.error("error", error);
          if (error.message.includes("403")) {
            handleResponse("Error !", "The session token is invalid", true);
          } else {
            handleResponse(
              "Error !",
              "Something went wrong… Please, try again",
              false
            );
          }
          return;
        })
        .finally(() => {
          setIsLoaded(false);
          setIsDisable(false);
        });
    } else {
      handleResponse("Warning !", "There aren't any chosen pupils.", false);
    }
  };

  return (
    <div>
      <Dialog open={showzoommodal} id="zoomPopupDialogContainer" scroll="paper">
        <DialogTitle className="zoomPopupDialogTitleSec">
          <div className="zoomPopupDialogTitleDiv">
            <div>
              <p className="zoomPopupDialogTitle">Students</p>
              {selectedStudents.length !== 0 ? (
                <span>{`(${selectedStudents.length} selected)`}</span>
              ) : null}
            </div>
            <span className="zoomPopupDialogTitleCaption">
              You can warn the students before removing them from the test or
              batch.
            </span>
          </div>
          <div>
            <Search onChange={handleSearch} />
          </div>
          <svg
            className="zoomPopupDialogCloseIcon"
            onClick={handleCloseDialog}
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M18 6L6 18M6 6L18 18"
              stroke="#667085"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </DialogTitle>
        <DialogContent id="zoomPopupDialogContentContainer">
          {Object.keys(filteredBatchStudents).length > 0 ? (
            <ZoomBatchCarousel
              batchdata={filteredBatchStudents}
              setBatchData={setFilteredBatchStudents}
              selectedStudents={selectedStudents}
              setSelectedStudents={setSelectedStudents}
              batchStudentsData={batchStudentsData}
            />
          ) : (
            <p>No data</p>
          )}
        </DialogContent>
        <DialogActions id="zoomPopupDialogActionContainer">
          <div className="zoomPopupDialogActionSec">
            <Button
              disable={!selectedStudents.length > 0}
              size="sm"
              hierarchy={{ type: "secondaryColor", buttonText: "Warn" }}
              onClick={() => handleOpenPopup(constants.TEST_ACTIONS.WARN)}
            />
            <Button
              disable={!selectedStudents.length > 0}
              size="sm"
              hierarchy={{
                type: "secondaryColor",
                buttonText: "Remove from Test",
              }}
              onClick={() =>
                handleOpenPopup(constants.TEST_ACTIONS.REMOVE_FROM_TEST)
              }
            />
            <Button
              disable={!selectedStudents.length > 0}
              size="sm"
              hierarchy={{
                type: "secondaryColor",
                buttonText: "Remove from Batch",
              }}
              onClick={() =>
                handleOpenPopup(constants.TEST_ACTIONS.REMOVE_FROM_BATCH)
              }
            />
            <Button
              size="sm"
              hierarchy={{ type: "linkGrey", buttonText: "Cancel" }}
              onClick={handleCloseDialog}
            />
          </div>
        </DialogActions>
        <Popup
          open={openPopup}
          title={popupTitleCom}
          body={
            <TextField
              id="popupBodyTextField"
              multiline
              value={popupBodyValue}
              onChange={(event) => setPopupBodyValue(event.target.value)}
              fullWidth
            />
          }
          actions={
            <>
              <Button
                size="lg"
                hierarchy={{ type: "secondaryGrey", buttonText: "Cancel" }}
                onClick={handleClosePopup}
              />
              <Button
                size="lg"
                disable={isDisable}
                hierarchy={{ type: "primary", buttonText: primaryBtnText }}
                onClick={handleTestAction}
              />
            </>
          }
        />
      </Dialog>
      {isLoaded && <Loading />}
    </div>
  );
};

export default ZoomPopup;
